exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._3tbR37jFil7vsHsK_O_YEy .ant-select-selector {\n  border: none !important;\n}\n", "", {"version":3,"sources":["/home/forge/leadpm.io/frontend/src/Screens/Subbies/Components/SubValuations/Components/Table/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;CACzB","file":"styles.css","sourcesContent":[".antInput :global(.ant-select-selector) {\n  border: none !important;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"antInput": "_3tbR37jFil7vsHsK_O_YEy"
};